import React, { useEffect, useRef } from "react";

const Successstories = () => {
  const reviewsRef = useRef(null);

  const reviews = [
    {
      name: "Rithika Pillai",
      img: "/customer4.jpg",
      text: "Myprega’s approach is the future of pregnancy care. Their use of technology to monitor daily health, team of 9 different medical specialist for each pregnant individual and provide on-demand support is incredible. I haven’t come across anything like this in India. They’re truly the best pregnancy partner for moms.",
    },
    {
      name: "Gayatri Navale",
      img: "/customer3.jpg",
      text: "The Myprega team went above and beyond to make my pregnancy comfortable. The diet plan was personalized for my needs, and the yoga sessions kept me active. Their user-friendly pregnancy care platform is amazing. Tracking my health and appointments was so easy. It felt like having a personal pregnancy assistant.",
    },
    {
      name: "Garad",
      img: "/customer1.jpg",
      text: "Choosing Myprega was the best decision I made for my wife’s pregnancy journey. Their doctors are so knowledgeable yet so kind. They made us feel like family, not just a patient. From consultations to ultrasounds, everything was perfectly organized through their tech platform, and I didn’t have to worry about a thing. The daily health tracking feature gave us so much peace of mind.",
    },
    {
      name: "Asha Gadge",
      img: "/customer3.jpg",
      text: "I had a few complications during my pregnancy, and Myprega was there for me every step of the way. Their 24/7 support and organized care managed through their innovative technology platform made all the difference. The team is truly compassionate, and all the 9 doctors panel are the best I’ve ever met. Their doctors and team treat me like family in my whole pregnancy journey. Highly recommended.",
    },
    {
      name: "Gayatri",
      img: "/customer4.jpg",
      text: "Myprega is a blessing for all pregnant women in Pune. They provide everything you need in one package. Consultations, tests, yoga, diet plans, and even emotional support. Their technology managed all my schedules, reports and other things. I felt so loved and cared for throughout my pregnancy. Their team and doctors treat me like family during whole pregnancy journey.",
    },
    {
      name: "Pratiksha Pathare",
      img: "/customer3.jpg",
      text: "Pregnancy care in India has long needed an upgrade, and Myprega has stepped in to transform it completely. Their integration of technology in pregnancy management is unmatched. It’s inspiring to see such an innovative and empathetic approach to maternal health. I’d choose Myprega without a second thought.",
    },
    {
      name: "Dhanashree Korke",
      img: "/customer4.jpg",
      text: "The Myprega package is worth every penny. Their transparency and care made me feel secure throughout my pregnancy. The doctors were always so patient, answering all my questions without rushing. I loved the personalized care plans and the constant support through their innovative tech platform.",
    },
    {
      name: "Gayatri",
      img: "/customer3.jpg",
      text: "The Garbhasanskar program was my favorite part of Myprega’s package. It was such a beautiful way to connect with my baby. The team of 9 doctors of different specialities and team were always so warm and caring. Their innovative platform daily tracked my pregnancy health which helped me manage hypertension during pregnancy. Very innovative way of delivering pregnancy care. I always felt like family.",
    },
    {
      name: "Priya Misal",
      img: "/customer4.jpg",
      text: "I had a few complications during my pregnancy, and Myprega was there for me every step of the way. Their 24/7 support and organized care managed through their innovative platform made all the difference. The team is truly compassionate, and the doctors are the best I’ve ever met. Five star rating to Myprega.",
    },
    {
      name: "Anonymous Mom",
      img: "/customer1.jpg",
      text: "I like the easy access to my daily pregnancy records, alerts on when consultation and labs are due, and the opportunity to ask questions anytime. Myprega simplified my pregnancy journey.",
    },
    {
      name: "Anonymous Mom Buddy",
      img: "/customer2.jpg",
      text: "The responsibility of caring for pregnant mothers lies on the shoulders of family, public health systems and volunteers, who often struggle to navigate unorganised care and Myprega is the only solution for this problem.",
    },
    {
      name: "Early Supporter",
      img: "/customer3.jpg",
      text: "Myprega is changing the traditional pregnancy care with their technology driven solution and I'm proud to be pioneers for this vision.",
    },
    {
      name: "Anonymous Mom",
      img: "/customer4.jpg",
      text: "At Myprega, nothing is out of reach when it comes to getting connected to your doctor. Incredible, how everything in my journey is so organized.",
    },
  ];

  useEffect(() => {
    const node = reviewsRef.current;
    let isPaused = false;

    if (!node) {
      return undefined;
    }

    const autoSlide = () => {
      if (isPaused || window.innerWidth >= 992 || !node.firstElementChild) {
        return;
      }

      const firstCard = node.firstElementChild;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = 16;
      const nextLeft = node.scrollLeft + cardWidth + gap;
      const maxLeft = node.scrollWidth - node.clientWidth;

      node.scrollTo({
        left: nextLeft >= maxLeft - 4 ? 0 : nextLeft,
        behavior: "smooth",
      });
    };

    const pauseSlider = () => {
      isPaused = true;
    };

    const resumeSlider = () => {
      isPaused = false;
    };

    node.addEventListener("touchstart", pauseSlider, { passive: true });
    node.addEventListener("touchend", resumeSlider);
    node.addEventListener("touchcancel", resumeSlider);
    node.addEventListener("pointerdown", pauseSlider);
    node.addEventListener("pointerup", resumeSlider);
    node.addEventListener("pointercancel", resumeSlider);

    const intervalId = window.setInterval(autoSlide, 2000);

    return () => {
      window.clearInterval(intervalId);
      node.removeEventListener("touchstart", pauseSlider);
      node.removeEventListener("touchend", resumeSlider);
      node.removeEventListener("touchcancel", resumeSlider);
      node.removeEventListener("pointerdown", pauseSlider);
      node.removeEventListener("pointerup", resumeSlider);
      node.removeEventListener("pointercancel", resumeSlider);
    };
  }, []);

  return (
    <div className="success-page-wrapper success-stories-section">
      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="journey-title">
            Our success stories: <br />
            From the voice of <span className="pink-text">mom</span> and <span className="pink-text">mom buddies</span>
          </h2>
          <p className="journey-subtitle mx-auto">
            Don't just take our word for it; our moms love our care just as much as we do!
            Loved & Trusted by 10,000+ Moms. Rated 4.9 ★ on Google.
          </p>
        </div>

        <div className="row align-items-start mt-5">
          <div className="col-lg-5 sticky-illustration">
             <div className="illustration-container">
                <img src="/storiesM.png" alt="Success Illustration" className="img-fluid" />
                <div className="floral-decoration bottom-left"></div>
             </div>
          </div>

          <div className="col-lg-7">
            <div className="reviews-stack-shell">
              <div className="reviews-stack" ref={reviewsRef}>
                {reviews.map((review, index) => (
                  <div key={index} className="review-card-modern">
                    <div className="d-flex align-items-center mb-3">
                      <div className="reviewer-avatar">
                        <img src={review.img} alt={review.name} />
                      </div>
                      <div className="ms-3">
                        <div className="review-stars-modern">
                          {[...Array(5)].map((_, i) => <i key={i} className="bi bi-star-fill"></i>)}
                        </div>
                        <h5 className="reviewer-name">{review.name}</h5>
                        <p className="reviewer-tag">Myprega Review</p>
                      </div>
                    </div>
                    <p className="review-body">“{review.text}”</p>
                    <div className="leaf-decoration"></div>
                  </div>
                ))}
              </div>
              <div className="reviews-scroll-hint" aria-hidden="true">
                <span>Scroll for more stories</span>
              </div>
            </div>

            <div className="text-center mt-5 google-rating-box">
               <h4 className="fw-bold">Loved & Trusted by Moms: 4.9 <i className="bi bi-star-fill text-warning"></i></h4>
               <a href="https://maps.google.com" target="_blank" className="btn-google-reviews">
                 See Why Moms Trust Us
               </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Successstories;
